export default __webpack_public_path__ + "static/media/rail-system.3a8e843e.svg";